import {
    APP_INITIALIZER,
    EnvironmentProviders,
    ErrorHandler,
    makeEnvironmentProviders,
    Provider,
} from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { TraceService } from '@services/trace.service';

const providers: Provider[] = [
    {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler(),
    },
    {
        provide: TraceService,
        deps: [Router],
    },
    {
        provide: APP_INITIALIZER,
        useFactory: () => () => {},
        deps: [TraceService],
        multi: true,
    },
];

/**
 * Provide Sentry
 *
 * @export
 * @return {*}  {EnvironmentProviders}
 */
export function provideSentry(): EnvironmentProviders {
    return makeEnvironmentProviders([...providers]);
}
